module.exports = __webpack_public_path__ + "img/vino.5e575e75.jpeg";